




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class App extends Vue {
	@Prop()
	private mediaInfoMap!: any

	@Prop()
	private needPlaceholder!: any

	@Prop()
	private type!: any

	@Prop()
	private picName!: any

	private get list() {
		const imgList = this.mediaInfoMap && this.mediaInfoMap[this.type]

		if (imgList && imgList.length) {
			return imgList
		} else if (this.needPlaceholder) {
			return [
				{
					picName: this.picName,
				},
			]
		} else {
			return []
		}
	}

	private getURL(url: any) {
		if (url) {
			return url + '?imageMogr2/thumbnail/192x'
		} else {
			return ''
		}
	}
}
